import { FC, useCallback, MouseEvent } from 'react';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import GirlStub from '#webImages/girl-stub.webp';
import { useAdvertCardContext } from '#advert/components/card';
import { PictureForPhoto } from '#advert/components/picture-for-photo';
import advertCardPhotoCss from '../../assets/advert-card-photo.module.scss';

const Photo: FC = () => {
  const {
    showBottomSheet,
    advert,
    isAllowBottomSheet,
  } = useAdvertCardContext();

  const handlerClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    if (!isAllowBottomSheet) {
      return;
    }

    e.preventDefault();
    showBottomSheet();
  }, [isAllowBottomSheet, showBottomSheet]);

  return (
    <Link
      to={advert.url}
      state={{ routerConfig: RouterConfig.initForAdvertDetail(advert.id) }}
      className={advertCardPhotoCss.advertCardPhoto}
      onClick={handlerClick}
    >
      <PictureForPhoto
        photo={advert.photo}
        stub={GirlStub}
        className={advertCardPhotoCss.advertCardPhoto__image}
        isAllowAltFromPhoto
        width={200}
        height={240}
        fetchPriority="high"
      />
    </Link>
  );
};

export { Photo };
